import React from 'react';
import classNames from 'classnames';
import './Line.pcss';

type Props = {
  className?: string;
  text?: string;
  children?: React.ReactNode | React.ReactNode[];
  textPosition?: 'center' | 'left' | 'right';
};

export const Line = ({ className, text, children, textPosition }: Props) => {
  return (
    <div
      className={classNames(className, 'c-line', {
        'c-line--with-text': text,
        [`c-line--text-position--${textPosition}`]: textPosition,
      })}
    >
      {text || children}
    </div>
  );
};
